const CONFIG = {
    API_KEY: '2ec354b390b94f28140c1c88000a7318', // Replace with your actual API key
    BASE_URL: 'https://api.wheel-size.com/v2',
    SELECT2_OPTIONS: {
        theme: 'classic',
        width: '100%',
        placeholder: 'Select an option',
        allowClear: true
    }
};